import { freezeAdminKeyedConfigRegistry } from "../registry_engine";

export const DEFAULT_WORKSPACE_STATE = Object.freeze({
  activeTab: "users",
  panelMode: "info",
  panelContext: null,
  panelKey: 0,
  isFullscreen: false,
});

export const WORKSPACE_ACTIONS = Object.freeze({
  CHANGE_TAB: "workspace/change-tab",
  OPEN_PANEL: "workspace/open-panel",
  CLOSE_PANEL: "workspace/close-panel",
  RESET: "workspace/reset",
  TOGGLE_FULLSCREEN: "workspace/toggle-fullscreen",
  SYNC_PANEL: "workspace/sync-panel",
});

export const PANEL_QUERY_REGISTRY = freezeAdminKeyedConfigRegistry({
  hr_employees: {
    tab: "hr",
    panelMode: "hr_employees",
  },
  cash_dashboard: {
    tab: "cash-management",
    panelMode: "cash_dashboard",
  },
  x_report: {
    tab: "cash-management",
    panelMode: "cash_dashboard_x",
  },
  z_report: {
    tab: "cash-management",
    panelMode: "cash_dashboard_z",
  },
  z_history: {
    tab: "cash-management",
    panelMode: "cash_dashboard_history",
  },
});

export function createWorkspaceState(overrides = {}) {
  return {
    ...DEFAULT_WORKSPACE_STATE,
    ...overrides,
  };
}

export function resolveWorkspacePanelQuery(
  panelQuery,
  registry = PANEL_QUERY_REGISTRY
) {
  if (!panelQuery) {
    return null;
  }

  return registry[panelQuery] || null;
}

export function workspaceReducer(state, action) {
  switch (action.type) {
    case WORKSPACE_ACTIONS.CHANGE_TAB:
      return {
        ...state,
        activeTab: action.tabKey,
        panelMode: "info",
        panelContext: null,
        panelKey: state.panelKey + 1,
        isFullscreen: false,
      };

    case WORKSPACE_ACTIONS.OPEN_PANEL:
      return {
        ...state,
        activeTab: action.tabKey || state.activeTab,
        panelMode: action.panelMode,
        panelContext: action.panelContext ?? null,
        panelKey: state.panelKey + 1,
        isFullscreen: false,
      };

    case WORKSPACE_ACTIONS.CLOSE_PANEL:
      return {
        ...state,
        panelMode: "info",
        panelContext: null,
        isFullscreen: false,
      };

    case WORKSPACE_ACTIONS.RESET:
      return {
        ...state,
        panelMode: "info",
        panelContext: null,
        panelKey: state.panelKey + 1,
        isFullscreen: false,
      };

    case WORKSPACE_ACTIONS.TOGGLE_FULLSCREEN:
      if (state.panelMode === "info") {
        return state;
      }

      return {
        ...state,
        isFullscreen: !state.isFullscreen,
      };

    case WORKSPACE_ACTIONS.SYNC_PANEL:
      return {
        ...state,
        activeTab: action.tabKey,
        panelMode: action.panelMode,
        panelContext: null,
        isFullscreen: false,
      };

    default:
      return state;
  }
}
